export default __webpack_public_path__ + "static/media/arrow.77973172.png";